import Base from '#BASE/store/chat/chat.store.mutations'
import CONSTANT from 'BASE/common/chat/chat.constant'
export default class extends Base {
    constructor() {
        super();
    }

    getMessageNameMySelf(state) {
        return state.loginId;
    }

    getMessageNameOthers(room, member) {
        return member.loginId;
    }

    getRoomName(type, name, members) {
        switch (type) {
            case CONSTANT.roomType.SYSTEM:
                return "系统讯息";
            case CONSTANT.roomType.CUSTOMER_SERVICE:
                return "客服人员";
            case CONSTANT.roomType.ANCESTOR:
                return "上级用户";
            case CONSTANT.roomType.DESCENDANT:
                return members[0].loginId;
            default:
                return name;
        }
    }
}
